import { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import LogsPicker from './LogsPicker';
import LogsViewer from './LogsViewer';
import { LOGS } from './logsConfig';
import './Logs.css';

function Logs() {
  const [selectedKey, setSelectedKey] = useState(null);

  const config = LOGS.find((l) => l.key === selectedKey);

  return (
    <div className="log-page">
      <Navbar />
      <main className="log-main">
        {config ? (
          <LogsViewer config={config} onBack={() => setSelectedKey(null)} />
        ) : (
          <LogsPicker onSelect={setSelectedKey} />
        )}
      </main>
    </div>
  );
}

export default Logs;
